import gql from 'graphql-tag';

import discoveryCollectionsGql from 'js/lib/discoveryCollectionsGql';
import enterpriseBadgeCollectionsGql from 'js/lib/enterpriseBadgeCollectionsGql';

export type AcademicDisciplineSummariesResult = {
  AcademicDiscipline: {
    queryAcademicDisciplineById: {
      name: string;
    };
  };
};

export type AcademicDisciplineNameQueryVariables = {
  disciplineId: string;
};

export const AcademicDisciplineNameQuery = gql`
  query AcademicDisciplineNameQuery($disciplineId: String!) {
    AcademicDiscipline {
      queryAcademicDisciplineById(id: $disciplineId) {
        name
      }
    }
  }
`;

export const DiscoveryBrowseCollectionsQuery = discoveryCollectionsGql`
query DiscoveryBrowseCollectionsQuery($contextType: String!, $contextId: String!, $programId: String!, $start: Int!, $limit: Int!) {
  DiscoveryCollections {
    queryEnterpriseCollectionsByProgram(
      input: {
        contextType: $contextType, 
        contextId: $contextId,
        programId: $programId, 
        cursor: {
          start: $start, 
          limit: $limit
        }
      }
      ) {
        productCollections {
          id
          label
          linkedCollectionPageMetadata {
            url
          }
          entities {
            __typename
            id
            slug
            name
            url
            partnerIds
            partners {
              id
              name
              logo
            }
            imageUrl
            ... on DiscoveryCollections_specialization {
              courseCount
              productCard {
                productTypeAttributes {
                  ... on ProductCard_Specialization {
                    isPathwayContent
                  }
                }
              }
            }
            ... on DiscoveryCollections_professionalCertificate {
              productCard {
                productTypeAttributes {
                  ... on ProductCard_Specialization {
                    isPathwayContent
                  }
                }
              }
            }
            ... on DiscoveryCollections_course {
              productCard {
                productTypeAttributes {
                  ... on ProductCard_Course {
                    isPathwayContent
                  }
                }
              }
              enterpriseCustomSessions {
                courseId
                startsAt {
                  seconds
                }
                endsAt {
                  seconds
                }
              }
            }
            ... on DiscoveryCollections_guidedProject {
              productCard {
                productTypeAttributes {
                  ... on ProductCard_Course {
                    isPathwayContent
                  }
                }
              }
              enterpriseCustomSessions {
                courseId
                startsAt {
                  seconds
                }
                endsAt {
                  seconds
                }
              }
            }
          }
        }
      next
    }
  }
}
`;

export const EnterpriseBadgeCollectionsQuery = enterpriseBadgeCollectionsGql`
  query EnterpriseBadgeCollectionsQuery($userId: String!, $programId: String!) {
      EnterpriseBadge {
        findByUserAndProgram(userId: $userId, programId: $programId) {
          badgeCollectionsWithUserState {
            title
            collectionId
            badgeTemplateId
            description
            learningObjectives
            imageUrl
            userState
            slug
            productIds {
              id
              type
            }
          }
        }
      }
  }
`;

export const EnterpriseBadgesCoursesSessionDatesQuery = gql`
  query EnterpriseBadgesCoursesSessionDatesQuery($courseIds: [String!]!, $programId: String!) {
    EnterpriseProgramSessionAssociationsV1Resource {
      byProgramAndCourses(courseIds: $courseIds, programId: $programId, limit: 50) {
        elements {
          id
          session {
            id
            courseId
            startsAt
            endsAt
          }
        }
      }
    }
  }
`;

export const S12nSessionDatesQuery = gql`
  query S12nSessionDatesQuery($ids: [String!]!) {
    OnDemandCourseSessionsV1Resource {
      multiGet(ids: $ids) {
        elements {
          id
          startsAt
          endsAt
        }
      }
    }
  }
`;
